import { T } from "@/locales";

export default [
  {
    title: T("序号"),
    dataIndex: "index",
    fixed: "left",
    width: 60,
    customRender: (value, item, index) => index + 1,
  },
  {
    title: T("序列号"),
    dataIndex: "number",
    fixed: "left",
    width: 240,
  },
  {
    title: T("货主"),
    dataIndex: "client_name",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("货品编号"),
    dataIndex: "material_number",
    width: 180,
    ellipsis: true,
  },
  {
    title: T("货品名称"),
    dataIndex: "material_name",
    width: 240,
    ellipsis: true,
  },
  {
    title: T("货品规格"),
    dataIndex: "material_spec",
    width: 120,
    ellipsis: true,
  },
  {
    title: T("创建时间"),
    dataIndex: "create_time",
    width: 180,
    ellipsis: true,
  },
];
